import React from 'react';
import { Button } from 'ui';
import CodeModalFilterComponent from '../filters/CodeModalFilterComponent';
import TranscriptSelectDropdown from './TranscriptSelectDropdown';

const FILTER_STYLE = `.reports-page-filter .dropdown button { padding-left: 0 !important; }`;

const ReportDetailPanel = ({
  selected,
  projectID,
  transcripts,
  selectedTranscriptId,
  onTranscriptChange,
  filters,
  onFilterChange,
  handleExport,
  exporting,
  disabled,
}) => {
  const isTranscriptDropdownReport = selected.kind === 'transcript-select' || selected.kind === 'coded-transcript-select';

  return (
    <div style={{ flex: 1, minWidth: '420px', padding: '16px 48px 32px', overflowY: 'auto' }}>
      <h2 style={{ marginTop: 0, marginBottom: '16px', fontSize: '20px' }}>{selected.name}</h2>

      {isTranscriptDropdownReport && (
        <div style={{ marginBottom: '24px' }}>
          <TranscriptSelectDropdown
            transcripts={transcripts}
            value={selectedTranscriptId}
            onChange={onTranscriptChange}
          />
        </div>
      )}

      {selected.hasFilter && (
        <>
          <p style={{ color: '#444', marginBottom: '4px' }}>
            Filter what to include in the export
          </p>
          <style>{FILTER_STYLE}</style>
          <div className="reports-page-filter" style={{ marginBottom: '12px' }}>
            <CodeModalFilterComponent
              projectID={projectID}
              requiredCodeId={null}
              filters={filters}
              onFilterChange={onFilterChange}
              onApplyFilter={() => {}}
              source="reports_page"
            />
          </div>
        </>
      )}

      <p style={{ color: '#222', marginBottom: '24px', lineHeight: 1.5 }}>
        {selected.description}
      </p>

      <Button
        variant="blue"
        onClick={handleExport}
        disabled={disabled}
        style={{ marginBottom: '32px', padding: '12px 24px', fontSize: '15px' }}
      >
        {exporting ? 'Exporting...' : selected.buttonLabel}
      </Button>

      <div>
        <div style={{ fontWeight: 700, marginBottom: '8px' }}>Includes</div>
        <ul style={{ margin: 0, paddingLeft: '20px', color: '#222', lineHeight: 1.7 }}>
          {selected.includes.map((line) => (
            <li key={line}>{line}</li>
          ))}
        </ul>
      </div>

      {selected.image && (
        <img
          src={selected.image}
          alt={selected.name}
          style={{ display: 'block', width: '100%', maxWidth: '640px', marginTop: '16px' }}
        />
      )}
    </div>
  );
};

export default ReportDetailPanel;
